import { render, staticRenderFns } from "./LookVirtualPoi.vue?vue&type=template&id=1a8b8548&scoped=true"
import script from "./LookVirtualPoi.vue?vue&type=script&lang=ts"
export * from "./LookVirtualPoi.vue?vue&type=script&lang=ts"
import style0 from "./LookVirtualPoi.vue?vue&type=style&index=0&id=1a8b8548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8b8548",
  null
  
)

export default component.exports